import React, { useEffect } from "react";
import { Link, scroller } from "react-scroll";
import { IoIosArrowForward, IoIosArrowBack } from "react-icons/io";

const EventPagination = ({
  items,
  currentIndex,
  setCurrentIndex,
  HEADER_HEIGHT,
}) => {
  const scrollToIndex = (index) => {
    setCurrentIndex(index);
    scroller.scrollTo(`flyer-${index}`, {
      duration: 500,
      smooth: true,
      offset: -HEADER_HEIGHT,
    });
  };

  useEffect(() => {
    // Ensure the first item is active on initial load
    scrollToIndex(0);
  }, []);

  const handlePrevClick = () => {
    if (currentIndex > 0) {
      scrollToIndex(currentIndex - 1);
    }
  };

  const handleNextClick = () => {
    if (currentIndex < items?.length - 1) {
      scrollToIndex(currentIndex + 1);
    }
  };

  return (
    <div className="fixed flex items-center justify-between bottom-4 left-6 right-6">
      <div className="relative flex items-center justify-center w-full px-16 bg-white h-14 rounded-[50px] border border-neutral-300 opacity-90">
        <button
          className="absolute left-4 disabled:opacity-25"
          aria-label="이전"
          onClick={handlePrevClick}
          disabled={currentIndex === 0}
        >
          <IoIosArrowBack className="text-2xl" />
        </button>
        <div className="flex items-center justify-center gap-2.5">
          {items?.map((_, index) => (
            <Link
              key={index}
              activeClass="bg-yellow-c-nobrand"
              to={`flyer-${index}`}
              spy={true}
              smooth={true}
              duration={500}
              offset={-HEADER_HEIGHT}
              className="flex items-center justify-center w-8 h-8 font-semibold rounded-[10px] cursor-pointer"
              spyThrottle={500}
              onSetActive={() => setCurrentIndex(index)}
            >
              {index + 1}
            </Link>
          ))}
        </div>
        <button
          className="absolute right-4 disabled:opacity-25"
          aria-label="다음"
          onClick={handleNextClick}
          disabled={currentIndex === items?.length - 1}
        >
          <IoIosArrowForward className="text-2xl" />
        </button>
      </div>
    </div>
  );
};

export default EventPagination;
